module.exports = __webpack_public_path__ + "static/media/15.fd11c7f6.gif";